import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { OpenIdConfiguration } from "angular-auth-oidc-client";
import { Subscription } from "rxjs";
import { HeaderState } from "src/app/models/header/HeaderState";
import { PrintedModalData } from "src/app/modules/CasingWear/models/printed";
import { MatSelGuidelinesComponentsService } from "src/app/modules/mat-sel-guidelines/services/mat-sel-guidelines-components.service";
import { LoginService } from "src/app/pages/auth/login/Login.service";
import { UserMgr } from "src/app/pages/usermgr/components/Usermgr.model";
import {
  UserCommentsModalComponent,
  UserCommentsData,
} from "src/app/shared/components/user-comments-modal/user-comments-modal.component";
import { ActionService } from "src/app/services/Action.service";
import { DataService } from "src/app/services/Data.service";
import { UserService } from "src/app/services/User.service";
import { environment } from "src/environments/environment";
import { NAVIGATIONS } from "../../consts/navigations";
import { PreSimulationService } from "../pre-simulation/service/pre-simulation.service";
import { NotificationsService } from "src/app/services/notifications/notifications.service";
import { ReportCountryMappingService } from "../../services/report-country-mapping.service";
import Swal from "sweetalert2";
import {
  HeaderActionsService,
  HeaderActionType,
} from "src/app/services/header-actions.service";

declare var jQuery: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  providers: [LoginService],
})
export class HeaderComponent implements OnInit {
  @ViewChild("userCommentsModal") userCommentsModal: UserCommentsModalComponent;

  // Notifications
  showNotifications = false;
  notifications: Array<{
    notificationId: number;
    commentId: number;
    commentText: string;
    commentCreatedDate: string;
    commentType: number;
    userId: number;
    seen: boolean;
    seenDate: string | null;
    userComments: Array<{
      id: number;
      userId: number;
      userName: string;
      userEmail: string;
      comment: string;
      createdDate: string;
    }>;
  }> = [];
  unreadCount = 0;
  dropdownTop = 60;
  dropdownLeft = 0;
  dropdownWidth = 320;
  isChatbotAdmin: boolean = false;
  userId: number;

  private subscriptions: Subscription[] = [];
  private headerActionsSubscription: Subscription;
  private originalReportCountry: string | null = null;

  constructor(
    private actionService: ActionService,
    private loginService: LoginService,
    private router: Router,
    private fb: UntypedFormBuilder,
    public dataService: DataService,
    private preSimulationService: PreSimulationService,
    private matSelGuidelinesComponentsService: MatSelGuidelinesComponentsService,
    private notificationsService: NotificationsService,
    private headerActionsService: HeaderActionsService,
    private reportCountryMappingService: ReportCountryMappingService
  ) {}

  ngOnInit() {
    this.currentUrl = this.router.url;

    this.dataService.currentValidateReportCWSource.subscribe(
      (validReport) => (this.validReportCw = validReport)
    );
    this.dataService.currentValidateReportCCSource.subscribe(
      (validReport) => (this.validReportCC = validReport)
    );
    this.dataService.currentValidateReportCRSource.subscribe(
      (validReport) => (this.validReportCR = validReport)
    );
    this.dataService.currentValidateReportSPSource.subscribe(
      (validReport) => (this.validReportSP = validReport)
    );
    this.dataService.currentValidateReportPRSource.subscribe(
      (validReport) => (this.validReportPR = validReport)
    );
    this.dataService.currentValidateReportMSGSource.subscribe(
      (validReport) => (this.validReportMSG = validReport)
    );
    this.dataService.currentValidateReportGEOSource.subscribe(
      (validReport) => (this.validReportGEO = validReport)
    );
    let createReportStoredValues = JSON.parse(
      sessionStorage.getItem("createReport")
    );

    this.dataService.currentRolSource.pipe().subscribe((roles) => {
      this.isChatbotAdmin = roles.some((x) => x == "CHATBOT_ADMIN");
    });

    this.fgCreateReport = this.fb.group({
      customer: [createReportStoredValues?.customer ?? ""],
      country: [createReportStoredValues?.country ?? ""],
      SDCaseNumber: [createReportStoredValues?.SDCaseNumber ?? ""],
      requestedBy: [createReportStoredValues?.requestedBy ?? ""],
      reviewedBy: [createReportStoredValues?.reviewedBy ?? ""],
      authorizedBy: [createReportStoredValues?.authorizedBy ?? ""],
      preMachiningManufacturer: [
        createReportStoredValues?.preMachiningManufacturer ?? "",
      ],
      printOnlyFirstPage: [
        createReportStoredValues?.printOnlyFirstPage ?? false,
      ],
      option1: [],
      option2: [],
      cra: [],
    });

    this.resetValidationPrintForm();

    this.dataService.simulationIdName$.subscribe((simulationPath) => {
      this.fgCreateReport.get("SDCaseNumber").setValue(simulationPath);
    });

    this.fgCreateReport.valueChanges.subscribe(() => {
      sessionStorage.setItem(
        "createReport",
        JSON.stringify(this.fgCreateReport.value)
      );
    });

    const chatRoutes = [
      NAVIGATIONS.CHAT.route,
      NAVIGATIONS.USER_MGR.route,
      NAVIGATIONS.DOCUMENTS.route,
      NAVIGATIONS.STATISTICS.route,
    ];

    this.router.events.subscribe(() => {
      this.currentUrl = this.router.url;
      this.actionService.changeAction(HeaderState.default);

      this.showModalReport = false;

      this.resetValidationPrintForm();

      if (this.currentUrl !== NAVIGATIONS.CHAT.route) {
        document.body.classList.remove("dark-mode");
      }

      if (chatRoutes.includes(this.currentUrl) && this.isChatbotAdmin) {
        this.notificationsService.getNotifications();
      }

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    });

    this.configurations = this.loginService.currentConfig();

    if (chatRoutes.includes(this.currentUrl) && this.isChatbotAdmin) {
      this.notificationsService.getNotifications();
    }

    this.dataService.currentNameSurnameSource.subscribe(
      (name) => (this.nameUser = name)
    );

    this.preSimulationService.customerDescriptionChanges$.subscribe(
      (description) => {
        this.fgCreateReport.get("customer").setValue(description);
      }
    );

    this.preSimulationService.countryDescriptionChanges$.subscribe(
      (description) => {
        this.originalReportCountry = description;
        this.fgCreateReport.get("country").setValue(description);
        this.applyReportCountryMapping();
      }
    );

    this.subscriptions.push(
      this.notificationsService.notifications$.subscribe((notif) => {
        if (notif) {
          if (Array.isArray(notif)) {
            this.notifications = [...notif].filter((n) => !Array.isArray(n));
          } else {
            const newNotif = notif;

            if (newNotif.userComments && newNotif.userComments.length > 0) {
              const userId = newNotif.userComments[0].userId;
              this.notifications.forEach((n) => {
                if (n.userComments && n.userComments[0]?.userId === userId) {
                  n.userComments = [...newNotif.userComments];
                }
              });
            }

            const exists = this.notifications.some(
              (n) => n.notificationId === newNotif.notificationId
            );
            if (!exists) this.notifications.unshift(newNotif);
          }

          this.updateUnreadCount();
        }
      }),
      this.notificationsService.notificationSeen$.subscribe(
        (notificationId) => {
          const notif = this.notifications.find(
            (n) => n.notificationId === notificationId
          );
          if (notif) notif.seen = true;
          this.updateUnreadCount();
        }
      )
    );

    this.headerActionsSubscription =
      this.headerActionsService.actionRequested$.subscribe((action) => {
        if (action.type === HeaderActionType.OpenPrintPdfModal) {
          this.openReportDetails();
        }
      });
  }

  toggleNotifications(event: MouseEvent, bellIcon: HTMLElement) {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications && bellIcon) {
      const rect = bellIcon.getBoundingClientRect();
      this.dropdownTop = rect.bottom;
      this.dropdownLeft = rect.right - this.dropdownWidth;
    }
  }

  updateUnreadCount() {
    this.notifications = this.notifications.slice().sort((a, b) => {
      if (a.seen !== b.seen) {
        return a.seen ? 1 : -1;
      }
      return (
        new Date(b.commentCreatedDate).getTime() -
        new Date(a.commentCreatedDate).getTime()
      );
    });

    this.unreadCount = this.notifications.filter((n) => !n.seen).length;
  }

  onNotificationClick(notif: any) {
    if (!notif.seen) {
      notif.seen = true;
      this.notificationsService.markNotificationAsSeen(notif.notificationId);
    }

    if (notif.userComments && notif.userComments.length > 0) {
      const commentsData: UserCommentsData = {
        userName: notif.userComments[0].userName,
        userEmail: notif.userComments[0].userEmail,
        comments: notif.userComments.map((c) => ({
          comment: c.comment,
          createdDate: c.createdDate,
          commentType: c.commentType,
        })),
      };
      this.userCommentsModal.open(commentsData);
    }
  }
  @Input()
  showCorrosionClas: boolean;
  showCorrosionRate: boolean;
  showCasingWear: boolean;
  showIcons: boolean;
  nameUser: string = null;
  @Input() imagePath: any;
  configurations: OpenIdConfiguration[];

  enabledButtonReportCC: boolean = true;
  message: string;
  subscription: Subscription;
  userMgrDataArray: UserMgr[];
  userMgrData: UserMgr;
  showModalReport = false;
  currentUrl: string = "";

  fgCreateReport: UntypedFormGroup;

  validReportCw: boolean = false;
  isOutputVisible: boolean = false;
  isSimulationSaved: boolean = false;
  validReportCR: boolean = false;
  validReportCC: boolean = false;
  validReportSP: boolean = false;
  validReportPR: boolean = false;
  validReportMSG: boolean = false;
  validReportGEO: boolean = false;
  readonly NAVIGATIONS = NAVIGATIONS;

  opt1: boolean = false;
  opt2: boolean = false;
  cra: boolean = false;

  logout(configId: string) {
    this.loginService.logout(configId);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscription.unsubscribe();
  }

  onReportClickCcValidate(): void {
    this.showModalReport = false;
    this.actionService.changeAction(HeaderState.validate);
    if (
      this.validReportCC == true &&
      this.preSimulationService.getFormLoadedValidity() &&
      this.validateIfPreSimulationSaved(
        this.preSimulationService.getSavedCustomerId(),
        this.preSimulationService.getSavedCountryId()
      )
    ) {
      this.openReportDetails();
    }
  }

  onReportClickCwValidate(): void {
    this.showModalReport = false;
    this.actionService.changeAction(HeaderState.validate);
    if (
      this.validReportCw == true &&
      this.preSimulationService.getFormLoadedValidity()
    )
      this.openReportDetails();
  }

  onReportClickCRValidate(): void {
    this.showModalReport = false;
    this.actionService.changeAction(HeaderState.validate);
    if (
      this.validReportCR == true &&
      this.preSimulationService.getFormLoadedValidity() &&
      this.validateIfPreSimulationSaved(
        this.preSimulationService.getSavedCustomerId(),
        this.preSimulationService.getSavedCountryId()
      )
    ) {
      this.openReportDetails();
    }
  }

  onReportClickSPValidate(): void {
    this.showModalReport = false;
    this.actionService.changeAction(HeaderState.validate);
    if (
      this.validReportSP == true &&
      this.preSimulationService.getFormLoadedValidity() &&
      this.validateIfPreSimulationSaved(
        this.preSimulationService.getSavedCustomerId(),
        this.preSimulationService.getSavedCountryId()
      )
    )
      this.openReportDetails();
  }

  onReportClickPRValidate(): void {
    this.showModalReport = false;
    this.actionService.changeAction(HeaderState.validate);
    if (
      this.validReportPR == true &&
      this.preSimulationService.getFormLoadedValidity() &&
      this.validateIfPreSimulationSaved(
        this.preSimulationService.getSavedCustomerId(),
        this.preSimulationService.getSavedCountryId()
      )
    )
      this.openReportDetails();
  }

  onReportClickMSGValidate(): void {
    this.showModalReport = false;
    this.actionService.changeAction(HeaderState.validate);
    if (
      this.validReportMSG == true &&
      this.preSimulationService.getFormLoadedValidity() &&
      this.validateIfPreSimulationSaved(
        this.preSimulationService.getSavedCustomerId(),
        this.preSimulationService.getSavedCountryId()
      )
    ) {
      this.opt1 = this.matSelGuidelinesComponentsService.getIsPrinteableOpt1()
        ? true
        : false;
      this.opt2 = this.matSelGuidelinesComponentsService.getIsPrinteableOpt2()
        ? true
        : false;
      this.cra = this.matSelGuidelinesComponentsService.getIsPrinteableCra()
        ? true
        : false;

      this.fgCreateReport.get("option1").setValue(this.opt1);

      if (!this.opt1) this.fgCreateReport.get("option1").disable();

      this.fgCreateReport.get("option2").setValue(this.opt2);

      if (!this.opt2) this.fgCreateReport.get("option2").disable();

      this.fgCreateReport.get("cra").setValue(this.cra);

      if (!this.cra) this.fgCreateReport.get("cra").disable();

      this.openReportDetails();
    }
  }

  onReportCountryInput(replacement: string): void {
    if (!this.originalReportCountry) return;

    try {
      this.reportCountryMappingService.remember(this.originalReportCountry, replacement);
    } catch (error: unknown) {
      this.showReportCountryMappingError(error);
    }
  }

  private openReportDetails(): void {
    this.applyReportCountryMapping();
    this.showModalReport = true;
  }

  private applyReportCountryMapping(): void {
    if (!this.originalReportCountry) return;

    try {
      const country = this.reportCountryMappingService.resolve(this.originalReportCountry);
      this.fgCreateReport.get("country").setValue(country);
    } catch (error: unknown) {
      this.showReportCountryMappingError(error);
    }
  }

  private showReportCountryMappingError(error: unknown): void {
    Swal.fire({
      icon: "warning",
      title: "Unable to remember report country",
      text: error instanceof Error ? error.message : String(error),
    });
  }

  validatePrint() {
    this.showModalReport = false;
    this.headerActionsService.requestAction(HeaderActionType.ValidatePrintPdf);
  }

  validatePrintCsv() {
    this.headerActionsService.requestAction(HeaderActionType.ValidatePrintCsv);
  }

  private validateIfPreSimulationSaved(
    customerId: number | null,
    countryId: number | null
  ): boolean {
    let isSaved = true;

    if (
      this.preSimulationService.getCurrentCountryId() == null ||
      this.preSimulationService.getCurrentCustomerId() == null ||
      this.preSimulationService.getCurrentCountryId() != countryId ||
      this.preSimulationService.getCurrentCustomerId() != customerId
    )
      isSaved = false;

    return isSaved;
  }

  private resetValidationPrintForm() {
    this.dataService.changeValidateReportCW(false);
    this.dataService.changeValidateReportCR(false);
    this.dataService.changeValidateReportCC(false);
    this.dataService.changeValidateReportSP(false);
    this.dataService.changeValidateReportPR(false);
    this.dataService.changeValidateReportMSG(false);
  }

  onReportClick(): void {
    if (this.fgCreateReport.invalid) {
      this.fgCreateReport.markAllAsTouched();
      return;
    }

    let printedModalData: PrintedModalData = {
      SDCaseNumber: this.fgCreateReport.get("SDCaseNumber").value,
      requestedBy: this.fgCreateReport.get("requestedBy").value,
      reviewedBy: this.fgCreateReport.get("reviewedBy").value,
      authorizedBy: this.fgCreateReport.get("authorizedBy").value,
      printOnlyFirstPage: this.fgCreateReport.get("printOnlyFirstPage").value,
      preMachiningManufacturer: this.fgCreateReport.get(
        "preMachiningManufacturer"
      ).value,
    };

    this.actionService.data = printedModalData;
    this.actionService.opt1Checked = this.fgCreateReport.get("option1").value;
    this.actionService.opt2Checked = this.fgCreateReport.get("option2").value;
    this.actionService.craChecked = this.fgCreateReport.get("cra").value;
    jQuery("#form-create-report").modal("hide");

    if (this.currentUrl === NAVIGATIONS.GEOTHERMAL.route || this.currentUrl === NAVIGATIONS.ADVANCED_PIPE.route) {
      this.headerActionsService.requestAction(
        HeaderActionType.PrintPdf,
        printedModalData
      );
    } else {
      this.actionService.changeAction(HeaderState.report);
    }
  }

  onDownloadClick(): void {
    this.actionService.changeAction(HeaderState.download);
  }

  onNewClick() {
    if (this.currentUrl === NAVIGATIONS.ADVANCED_PIPE.route) {
      this.headerActionsService.requestAction(HeaderActionType.New);
    } else {
      this.actionService.changeAction(HeaderState.new);
    }
  }

  onLinkToManualClick() {
    switch (this.currentUrl) {
      case NAVIGATIONS.CASING_WEAR.route:
        window.open(environment.manualsUrl.casingWear, "_blank");
        break;
      case NAVIGATIONS.CORROSION_CLAS.route:
        window.open(environment.manualsUrl.corrosionClas, "_blank");
        break;
      case NAVIGATIONS.CORROSION_RATE.route:
        window.open(environment.manualsUrl.corrosionRate, "_blank");
        break;
      case NAVIGATIONS.SLOTTED.route:
        window.open(environment.manualsUrl.slottedPipe, "_blank");
        break;
      case NAVIGATIONS.PERFORATED.route:
        window.open(environment.manualsUrl.prePerforatedPipe, "_blank");
        break;
      case NAVIGATIONS.MAT_SEL_GUIDELINES.route:
        window.open(environment.manualsUrl.matSelGuidelines, "_blank");
        break;
      case NAVIGATIONS.GEOTHERMAL.route:
        window.open(environment.manualsUrl.geothermal, "_blank");
        break;
      case NAVIGATIONS.ADVANCED_PIPE.route:
        window.open(environment.manualsUrl.advancedPipeRatings, "_blank");
        break;
      default:
        break;
    }
  }

  onDeleteClick() {
    this.actionService.changeAction(HeaderState.delete);
  }

  onLoadClick() {
    this.actionService.changeAction(HeaderState.load);
  }

  onSaveClick() {
    if (!this.preSimulationService.hasCustomerAndCountrySelected()) {
      Swal.fire({
        title: "Action required",
        text: "Please select customer and country to save simulation",
        icon: "warning",
        confirmButtonColor: "#009",
        cancelButtonColor: "#aaa",
      });
    } else {
      this.actionService.changeAction(HeaderState.save);
    }
  }

  showRightSidebar() {
    jQuery("#sidebar").addClass("active");
    jQuery(".overlay").addClass("active");
    jQuery(".collapse.in").toggleClass("in");
    jQuery("a[aria-expanded=true]").attr("aria-expanded", "false");
  }
}
